import * as React from "react";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";

import { cn } from "../../lib/utils";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../popover/popover-base";
import { Calendar } from "./calendar-base";
import { Button } from "../button";
import { CalendarIcon } from "../icon/calendar-icon";

export type CalendarProps = React.ComponentProps<typeof DayPicker> & {
  value?: Date;
  onChange?: (e?: string) => void;
  placeholder?: string;
  disabledDatePicker?: boolean;
  dateFormat?: string;
};

function CalendarInput({
  value,
  onChange,
  placeholder,
  disabledDatePicker,
  dateFormat,
  ...rest
}: CalendarProps) {
  const [isCalendarOpen, setIsCalendarOpen] = React.useState(false);

  const onSelect = (e: Date | undefined) => {
    onChange?.(e?.toISOString());

    setIsCalendarOpen(false);
  };

  return (
    <Popover open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
      <PopoverTrigger asChild>
        <Button
          disabled={disabledDatePicker}
          variant={"outline"}
          className={cn(
            "min-h-[40px] border disabled:text-gray-500 border-neutral-200 group-invalid:border-negative-500 rounded-[10px] flex items-center focus:border-neutral-600 focus:outline-none disable px-3 bg-transparent w-full h-full p-2.5 disabled:bg-neutral-200 invalid:border-pink-500 invalid:text-pink-60 focus:invalid:border-pink-500 focus:invalid:ring-pink-500",
            !value && "text-muted-foreground"
          )}
        >
          {value ? (
            format(value, dateFormat || "dd/MM/yyyy")
          ) : (
            <span>{placeholder || ""}</span>
          )}
          <input className="hidden" value={value?.toString()} type="text" />
          <div className="ml-auto h-4 w-4 opacity-50">
            <CalendarIcon />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          defaultMonth={value}
          captionLayout="dropdown-buttons"
          fromYear={rest.fromYear || 1900}
          toYear={rest.toYear || 2099}
          selected={value}
          disabled={rest.disabled}
          initialFocus
          mode="single"
          onSelect={onSelect}
        />
      </PopoverContent>
    </Popover>
  );
}
CalendarInput.displayName = "CalendarInput";

export { CalendarInput };
